import StatusBadge from "../StatusBadge";
import {
  transactionHistoryStatusList,
  transactionStatusMap
} from "services/constants";

interface StatusConfig {
  label?: string;
  textColorClass: string;
  bgColorClass: string;
  ellipseColorClass: string;
  showEllipse?: boolean;
}

interface StatusBadgeProps {
  status: string;
}

// Common status configuration
const getStatusConfig = (
  status: string,
  useCustomLabels = false
): StatusConfig | null => {
  if (!transactionHistoryStatusList.includes(status)) {
    return null;
  }

  switch (status) {
    case "SUCCESS":
      return {
        label: "Success",
        textColorClass: "text-success-foreground",
        bgColorClass: "bg-success",
        ellipseColorClass: "bg-success-foreground",
        showEllipse: true
      };
    case "FAILED":
      return {
        label: "Failed",
        textColorClass: "text-destructive",
        bgColorClass: "bg-destructive-foreground",
        ellipseColorClass: "bg-destructive",
        showEllipse: true
      };
    case "DEACTIVATED":
      return {
        label: "De-activated",
        textColorClass: "text-muted-foreground",
        ellipseColorClass: "bg-muted2-foreground",
        bgColorClass: "bg-muted2",
        showEllipse: false
      };
    case "UNDER_REVIEW":
      return {
        label: "Under Review",
        textColorClass: "text-warning-foreground",
        bgColorClass: "bg-warning",
        ellipseColorClass: "bg-warning-foreground",
        showEllipse: true
      };
    case "PENDING":
      return {
        label: "Pending",
        textColorClass: "text-warning-foreground",
        bgColorClass: "bg-warning",
        ellipseColorClass: "bg-warning-foreground",
        showEllipse: true
      };
    case "EXPIRED":
      return {
        label: "Expired",
        textColorClass: "text-muted-foreground",
        bgColorClass: "bg-muted2",
        ellipseColorClass: "bg-muted2-foreground",
        showEllipse: true
      };
    default:
      return {
        label: "",
        textColorClass: "",
        bgColorClass: "",
        ellipseColorClass: "",
        showEllipse: false
      };
  }
};

// Reusable status badge component
export const TransactionStatusBadge = ({ status }: StatusBadgeProps) => {
  const config = getStatusConfig(status);

  console.log("config", config);

  if (!config) {
    return null;
  }

  const { label, textColorClass, bgColorClass, showEllipse = true, ellipseColorClass } = config;

  // Use custom label if provided, otherwise fall back to transactionStatusMap

  return (
    <StatusBadge
      label={label}
      textColorClass={textColorClass}
      bgColorClass={bgColorClass}
      showEllipse={showEllipse}
      ellipseColorClass={ellipseColorClass}
      variant={"subtitle5"}
    />
  );
};
